import { create } from "zustand";
import {
  googleLoginAPI,
  updateUserProfileAPI,
  userLoginAPI,
  userOtpVerifyAPI,
  userSignupAPI,
} from "../API";
import { createJSONStorage, persist } from "zustand/middleware";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const userStore = create(
  persist(
    (set) => ({
      user: [],
      authToken: null,
      message: "",
      data: [],
      loading: false,
      error: "",

      userLogin: async (payload) => {
        set({ loading: true, error: null });

        try {
          const response = await userLoginAPI(payload);
          const resData = response?.data;

          if (response?.status === 200) {
            if (resData?.otpSend) {
              set({ data: resData, loading: false });
              toast.success(resData?.message || "OTP sent", { autoClose: 5000 });
              return;
            }
            if (resData?.authToken && resData?.userDetails) {
              set({
                user: resData.userDetails,
                authToken: resData.authToken,
                data: [],
                loading: false,
              });
              toast.success(resData?.message || "Login successful", { autoClose: 5000 });
              return;
            }
          }
          set({ loading: false });
          toast.error(resData?.message || "Login failed", { autoClose: 5000 });

        } catch (error) {
          console.error("Login Error:", error);
          set({ loading: false });
          toast.error(error?.response?.data?.message || error?.message || "Something went wrong", {
            autoClose: 5000,
          });
        }
      },

      userOtpVerify: async (params) => {
        set({ loading: true, error: null });
        try {
          const response = await userOtpVerifyAPI(params);
          if (response?.status == 200) {
            set({
              user: response?.data?.userDetails,
              authToken: response?.data?.authToken,
              data: [],
              loading: false,
            });
            toast.success(response?.data?.message, { autoClose: 5000 });
          } else {
            set({ loading: false });
            toast.error(response?.response?.data?.message || response?.message, {
              autoClose: 5000,
            });
          }
        } catch (error) {
          console.log("error", error);
          toast.error(error?.message || "Something went wrong", { autoClose: 5000 });
        }
      },

      userSignup: async (payload) => {
        set({ loading: true, error: null });
        try {
          const response = await userSignupAPI(payload);
          if (response?.data?.otpSend) {
            set({
              data: response?.data,
              loading: false,
            });
            toast.success(`Sign Up successful: ${response?.data?.message}`, {
              autoClose: 5000,
            });
          } else {
            set({ loading: false });
            toast.error(response?.message, { autoClose: 5000 });
          }
        } catch (error) {
          console.log("error", error);
          toast.error(error?.message || "Something went wrong", { autoClose: 5000 });
        }
      },

      googleLogin: async (credential) => {
        try {
          const { userDetails, authToken } = await googleLoginAPI(credential);
          set({ authToken, user: userDetails });
        } catch (err) {
          console.error(err.message);
          set({ error: err.message });
          toast.error(err.message || "Google login failed", { autoClose: 5000 });
        }
      },

      updateUserProfile: async (formData, userId) => {
        try {
          const { userDetails, authToken, message } = await updateUserProfileAPI(
            formData,
            userId
          );
          set({ user: userDetails, authToken });
          toast.success(message, { autoClose: 5000 });
        } catch (error) {
          console.error("Error updating profile in store:", error.message);
          set({ error: error.message });
          toast.error(error.message || "Profile update failed", { autoClose: 5000 });
        }
      },

      resetState: () => {
        set((state) => ({
          message: "",
          error: null,
          data: {
            ...state?.data,
            otpSend: false,
          },
        }));
      },

      logout: () => {
        localStorage.removeItem("UserStore");
        set({
          user: [],
          authToken: null,
          message: "",
          data: [],
          error: null,
        });
      },
    }),
    {
      name: "UserStore",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        authToken: state.authToken,
        data: state.data,
      }),
    }
  )
);

export default userStore;
